import { render, staticRenderFns } from "./ActivityRecords.vue?vue&type=template&id=74ac990a&scoped=true"
import script from "./ActivityRecords.vue?vue&type=script&lang=js"
export * from "./ActivityRecords.vue?vue&type=script&lang=js"
import style0 from "./ActivityRecords.vue?vue&type=style&index=0&id=74ac990a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac990a",
  null
  
)

export default component.exports